import routes from "@/routes";
import { lazy } from "react";
const Creative = lazy(() => import("@/modules/Asset/Creative"));
const ListGroupedCreative = lazy(
  () => import("@/modules/Asset/Creative/ListGroupedCreative")
);
const DetailGroupedCreative = lazy(
  () => import("@/modules/Asset/Creative/ListAsset")
);
const CreateOrEditAsset = lazy(
  () => import("@/modules/Asset/Creative/CreateOrEditAsset")
);
const DisplayDetailAsset = lazy(
  () => import("@/modules/Asset/Creative/DetailAsset")
);

const AssetRoutes = {
  element: <Creative />,
  path: routes.ASSETS.CREATIVES.INDEX,

  children: [
    {
      element: <ListGroupedCreative />,
      path: "",
    },
    {
      element: <CreateOrEditAsset />,
      path: routes.ASSETS.CREATIVES.CREATE,
    },
    {
      element: <CreateOrEditAsset isEdit />,
      path: routes.ASSETS.CREATIVES.EDIT(),
    },
    {
      element: <DetailGroupedCreative />,
      path: routes.ASSETS.CREATIVES.DETAIL(),
    },
    {
      element: <CreateOrEditAsset isAdd />,
      path: routes.ASSETS.CREATIVES.ADD(),
    },
    {
      element: <DisplayDetailAsset />,
      path: routes.ASSETS.CREATIVES.ASSOCIATION(),
    },
  ],
};

export default AssetRoutes;
